import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'percentFormat',
    standalone: false
})
export class PercentFormatPipe implements PipeTransform {
  transform(value: number, printPercent = true): string {

    if (value === null || value === undefined) {
      return '-NV-';
    }

    return Math.round(value * 100) + (printPercent ? '%' : '');
  }
}
